import { apiFetch } from "../utils/api";

export const getRoles = async () => {
  const res = await apiFetch("/api/roles");
  if (!res.ok) throw new Error("Failed to fetch roles");
  return res.json();
};